import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function initStatsAnimation() {
  document.querySelectorAll('[data-row-stat]').forEach(statsRow => {
    const numEls = statsRow.querySelectorAll('[data-stat]');
    if (!numEls.length) return;

    let animated = false;

    ScrollTrigger.create({
      trigger: statsRow,
      start: 'top 90%',

      onEnter() {
        if (animated) return;
        animated = true;
        numEls.forEach(el => {
          const target = parseInt(el.dataset.stat, 10);
          const counter = { val: 0 };
          el.textContent = '0';

          gsap.to(counter, { val: target, duration: 2, ease: 'expo.out', onUpdate() {
            el.textContent = Math.round(counter.val);
          }});
        });
      },
    });
  });
}
